import { getCard, type DrawnCard } from '@tarot/shared';

/**
 * 카드별 간단 운세 — 결과 화면에서 각 카드 아래에 표시.
 * 카드 이름 + 정/역방향 + 핵심 키워드 (전체 키워드는 카드 클릭 → 라이트박스)
 */
export function CardMeaning({ drawn, maxKeywords = 2 }: { drawn: DrawnCard; maxKeywords?: number }) {
  const card = getCard(drawn.cardId);
  const keywords = (drawn.reversed ? card.keywordsRev : card.keywordsUp)
    .slice(0, maxKeywords)
    .join(' · ');
  return (
    <span className="flex w-full flex-col items-center gap-0.5 pt-1.5 text-center">
      <span className="text-[12px] font-semibold leading-tight text-moon">{card.nameKo}</span>
      <span className="text-[11px] leading-tight text-moon-dim">
        <span className={drawn.reversed ? 'text-gold/80' : 'text-gold'}>
          {drawn.reversed ? '역방향' : '정방향'}
        </span>
        {' · '}
        {keywords}
      </span>
    </span>
  );
}
